// @ts-check
import dragonfly from 'dragonfly-v3';
import BaseHandler from './BaseHandler';

const POPUP_OFFSET = 40;

const CUSTOM_LOCATION_RESPONSE = 'CUSTOM_LOCATION_RESPONSE';
const PICK_MAP_POINT_RESPONSE = 'PICK_MAP_POINT_RESPONSE';

class UserLocationHandler extends BaseHandler {
    constructor(mapViewer) {
        super(mapViewer);
        this.setGluBusEvents({
            // Attach map click event for custom location selection
            CUSTOM_LOCATION_REQUEST: this.addMapEvents,
            CUSTOM_LOCATION_CANCEL: this.removeMapEvents,
            // Same pin drop on its own channel, so a form asking for a point does
            // not also move the map's location-analysis pin (which is what the
            // header map pin does with CUSTOM_LOCATION_RESPONSE)
            PICK_MAP_POINT_REQUEST: this.addPointPickEvents,
            PICK_MAP_POINT_CANCEL: this.removeMapEvents,
        });

        /** @type {import('mapbox-gl').Popup} */
        this._pinPopup = undefined;
        this._responseEvent = CUSTOM_LOCATION_RESPONSE;
    }

    onMouseUp = e => {
        this.emit(this._responseEvent, e.lngLat);
        this.removeMapEvents();
    };

    onMapMoveStart = () => {
        this.map.off('mouseup', this.onMouseUp);
    };

    onMapMoveEnd = () => {
        this.map.on('mouseup', this.onMouseUp);
    };

    onMouseMove = e => {
        /** @type {[number, number]} */
        const coordinates = [e.lngLat.lng, e.lngLat.lat];
        if (this._pinPopup) {
            this._pinPopup.setLngLat(coordinates);
        } else {
            // create popup
            this._pinPopup = new dragonfly.Popup({
                closeOnClick: false,
                closeButton: false,
                offset: POPUP_OFFSET,
            });
            this._pinPopup
                .setLngLat(coordinates)
                .setHTML('<div>Select a location</div>')
                .addTo(this.map);
            // add popup class and ignore ts problem, since there is no different
            // way to add a class to the popup container in the mapbox/dragonfly
            // version that we use
            // @ts-ignore
            this._pinPopup._container.classList.add(
                'select-user-location-popup',
            );
        }
    };

    addMapEvents = () => {
        this._responseEvent = CUSTOM_LOCATION_RESPONSE;
        this.armMapEvents();
    };

    addPointPickEvents = () => {
        this._responseEvent = PICK_MAP_POINT_RESPONSE;
        this.armMapEvents();
    };

    armMapEvents = () => {
        const canvas = this.map.getCanvas();
        canvas.style.cursor = 'crosshair';
        // ParcelsHandler skips the click that picks a point.
        this.mapViewer.isPickingLocation = true;

        this.map.on('mouseup', this.onMouseUp);
        this.map.on('movestart', this.onMapMoveStart);
        this.map.on('moveend', this.onMapMoveEnd);
        this.map.on('mousemove', this.onMouseMove);
    };

    removeMapEvents = () => {
        const canvas = this.map.getCanvas();
        canvas.style.cursor = 'default';
        this.mapViewer.isPickingLocation = false;
        // remove popup
        if (this._pinPopup) {
            this._pinPopup.remove();
            this._pinPopup = undefined;
        }

        this.map.off('mouseup', this.onMouseUp);
        this.map.off('movestart', this.onMapMoveStart);
        this.map.off('moveend', this.onMapMoveEnd);
        this.map.off('mousemove', this.onMouseMove);
    };
}

export default UserLocationHandler;
